import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
 
import { CardEmpComponent } from './card-emp.component';
import { NzIconModule } from 'ng-zorro-antd/icon'; 

const COMPONENTS = [CardEmpComponent];

@NgModule({
  imports: [CommonModule, NzAvatarModule, NzToolTipModule,NzIconModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class CardEmpModule {}
